import { FETCH_USERS2 } from '../constants';

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_USERS2:
      // console.log('src/Redux/reducers/usersReducer2.js: ', action.payload.data);
      return action.payload.data;
    default:
      return state;
  }
};
